import { agentHubRollout } from '@lumapps/agent-hub/ducks/selectors';
import { isFeatureEnabled } from '@lumapps/features';
import { isSuperAdmin, permissionsSelector } from '@lumapps/permissions';
import { createSelector } from '@lumapps/redux/reselect';

import { ASK_AI_ALPHA_FF, ASK_AI_BETA_FF, ASK_AI_FF } from '../constants';
import { AskAiFeatures } from '../types';

/** Check whether the AskAI FF is enabled in the store */
export const isAskAIEnabled = isFeatureEnabled(ASK_AI_FF);

/** Check whether the AskAi alpha FF is enabled */
export const isAskAiAlphaEnabled = isFeatureEnabled(ASK_AI_ALPHA_FF);

/** Check whether the AskAi beta FF is enabled */
export const isAskAiBetaEnabled = isFeatureEnabled(ASK_AI_BETA_FF);

/**
 * Retrieves whether the user can access the ask ai admin.
 */
export const canAccessAskAiAdmin = (state: BackOfficeStore) => isAskAIEnabled(state) && isSuperAdmin(state);
/**
 * Is the user allowed to use ask ai?
 */
export const canUseAskAiFeature = createSelector(
    permissionsSelector,
    isAskAIEnabled,
    (permissions, isAskEnabled) =>
        // Is ask ai feature enabled AND a configuration created for the user?
        isAskEnabled && permissions.authorizations.canReadAiAugmentedSearch,
);

/**
 * Retrieve whether the user can access tha ask ai admin features that are under development
 */
export const canAccessAskAiAdminAlphaFeatures = createSelector(
    canAccessAskAiAdmin,
    isAskAiAlphaEnabled,
    (canAccessAskAiAdmin, isAskAiAlphaEnabled) => canAccessAskAiAdmin && isAskAiAlphaEnabled,
);

/**
 * Retrieve whether the user can access the ask ai admin features that are in Beta
 */
export const canAccessAskAiAdminBetaFeatures = createSelector(
    canAccessAskAiAdmin,
    isAskAiBetaEnabled,
    isAskAiAlphaEnabled,
    (canAccessAskAiAdmin, isAskAiBetaEnabled, isAskAiAlphaEnabled) =>
        canAccessAskAiAdmin && (isAskAiBetaEnabled || isAskAiAlphaEnabled),
);

export const canAccessAskAiAlphaFeatures = createSelector(
    canUseAskAiFeature,
    isAskAiAlphaEnabled,
    (canUseAskAiFeature, isAskAiAlphaEnabled) => canUseAskAiFeature && isAskAiAlphaEnabled,
);

export const canAccessAskAiBetaFeatures = createSelector(
    canUseAskAiFeature,
    isAskAiBetaEnabled,
    (canUseAskAiFeature, isAskAiBetaEnabled) => canUseAskAiFeature && isAskAiBetaEnabled,
);

export const getAskAiFeatures = createSelector(
    canAccessAskAiBetaFeatures,
    agentHubRollout.isGA,
    (isAskBeta, isAgent) => {
        const features: AskAiFeatures = {
            isConversationalEnabled: isAskBeta,
            isAgentEnabled: isAgent,
        };

        return features;
    },
);
